module.exports = __webpack_public_path__ + "img/26_189.888abfbe.png";